"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeneratedKetteGuard = void 0;
const GeneratedArticle_1 = require("../GeneratedArticle");
/** Provide type guards for the different "useable" kinds. */
class GeneratedKetteGuard {
    static isGenerated(kette) {
        return (0, GeneratedArticle_1.isGeneratedArticle)(kette);
    }
}
exports.GeneratedKetteGuard = GeneratedKetteGuard;
//# sourceMappingURL=GeneratedKette.js.map